
import RangeSliderWithInput from "../../../MuiFields/RangeSliderWithInput";

import useTableStore from "../../../../store/table";

// context
import { useTableId } from "../../../../contexts/TableId";

const RangeSlider = ({ id, ...props }) => {
  const tableId = useTableId();
  const handleFilter = useTableStore(state => state.handleTableFilter);
  const range = useTableStore(state => state.tableFilters[tableId]?.[id]) || {};

  const handleChange = (e, fieldName, queryType, fieldType) => {
    console.log(e, "handleChange")
    handleFilter(e, tableId, fieldName, queryType, fieldType);
  }

  return (
    <RangeSliderWithInput id={id} handleChange={handleChange} value={range} {...props} />
  )
};

export default RangeSlider;
